import React from 'react';
import { Card, Alert, Spinner } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';
import './PermissionDenied.css';

const PermissionDenied = ({ 
  isLoading, 
  permissionName, 
  userAccountType,
  showAccountTypeInfo = true,
  isAccountTypeRestriction = false  // 新增：是否为账号类型限制
}) => {
  if (isLoading) {
    return (
      <div className="permission-denied-container">
        <Card className="permission-denied-card">
          <Card.Body className="permission-denied-loading">
            <Spinner animation="border" />
            <p>正在验证权限...</p>
          </Card.Body>
        </Card>
      </div>
    );
  }

  return (
    <div className="permission-denied-container">
      <Card className="permission-denied-card">
        <Card.Body className="permission-denied-card-body">
          <FaExclamationTriangle className="permission-denied-icon" />
          <h3 className="permission-denied-title">暂无权限访问</h3>
          
          {isAccountTypeRestriction ? (
            <p className="permission-denied-description">
              只有 <strong>主账号</strong> 可以访问 <strong>"{permissionName}"</strong> 功能。
            </p>
          ) : (
            <p className="permission-denied-description">
              您需要 <strong>"{permissionName}"</strong> 权限才能访问此功能。
            </p>
          )}
          
          {showAccountTypeInfo && (
            <Alert variant="info" className="permission-denied-alert">
              <strong>当前账号类型：</strong> 
              {userAccountType === 'main' && '主账号'}
              {userAccountType === 'ram' && 'RAM子账号'}
              {!userAccountType && '未知'}
              <br />
              <strong>权限说明：</strong>
              {isAccountTypeRestriction ? (
                userAccountType === 'ram' ? (
                  <span>如需使用{permissionName}功能，请联系主账号管理员。</span>
                ) : (
                  <span>如有问题请联系系统管理员。</span>
                )
              ) : (
                <>
                  {userAccountType === 'ram' && (
                    <span>请联系主账号管理员为您分配相应权限。</span>
                  )}
                  {userAccountType === 'main' && (
                    <span>主账号应该拥有所有权限，如有问题请联系系统管理员。</span>
                  )}
                  {!userAccountType && (
                    <span>请重新登录或联系系统管理员。</span>
                  )}
                </>
              )}
            </Alert>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PermissionDenied; 